import React from "react";
import Header from "../../components/Header";
import TextField from "../../components/TextField";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from "@mui/material";
import { ERROR_HELPERTEXT_STYLES, FIELD_ERROR_TEXT } from "../../utils";
import DateField from "../../components/DateField";

const Acknowledgement = ({
  data,
  setData,
  error,
  handleInputChange,
  handleCheckbox,
  setError,
  disabled,
  btnLoading,
}) => {
  return (
    <div>
      <Header text="Acknowledgement" />

      <div className="form_container">
        <div className="mb_16">
          <FormGroup>
            <FormControlLabel
              sx={{
                "&.MuiFormControlLabel-root": {
                  padding: ".5rem 0 0",
                  borderRadius: "5px",
                },

                ".MuiTypography-root": {
                  fontFamily: "Montserrat",
                  fontSize: "0.95rem",
                },
              }}
              required
              control={
                <Checkbox
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                  size="small"
                  sx={{
                    "&.Mui-checked": {
                      color: "#8ed1fc",
                    },
                    color: "#d9d9d9",
                  }}
                  name="terms_agreed"
                  checked={data?.terms_agreed}
                  onChange={handleCheckbox}
                />
              }
              disabled={disabled?.stage || btnLoading}
              label="I declare that I am authorized to disclose the information in this application and authorized to request a new Broker Code on behalf of the legal entity listed in this application."
            />
          </FormGroup>
          {error?.terms_agreed ? (
            <FormHelperText sx={ERROR_HELPERTEXT_STYLES}>
              {FIELD_ERROR_TEXT}
            </FormHelperText>
          ) : (
            ""
          )}
        </div>
        <TextField
          label="First name"
          name="first_name"
          value={data?.first_name}
          handleChange={handleInputChange}
          error_state={error?.first_name}
          error_text={FIELD_ERROR_TEXT}
          required
          disabled={disabled?.stage || btnLoading}
        />
        <TextField
          label="Last name"
          name="last_name"
          value={data?.last_name}
          handleChange={handleInputChange}
          error_state={error?.last_name}
          error_text={FIELD_ERROR_TEXT}
          required
          disabled={disabled?.stage || btnLoading}
        />
        <TextField
          label="Title"
          name="title"
          value={data?.title}
          handleChange={handleInputChange}
          error_state={error?.title}
          error_text={FIELD_ERROR_TEXT}
          required
          disabled={disabled?.stage || btnLoading}
        />
        <DateField
          label="Date"
          name="date"
          value={data?.date}
          handleChange={(date, dateString) => {
            if (date) {
              setData({ ...data, date: date });

              setError({ ...error, date: false });
            } else {
              setData({ ...data, date: "" });

              setError({ ...error, date: true });
            }
          }}
          error_state={error?.date}
          error_text={FIELD_ERROR_TEXT}
          required
          disabled={disabled?.stage || btnLoading}
        />
      </div>
    </div>
  );
};

export default Acknowledgement;
